<template>
  <div class="chart-ranking-usuarios">
    <no-hay-datos v-if="!dataset.length" />
    <div
      v-for="(dato, index) in datasetConPorcentaje"
      :key="dato.usuario.id"
      class="cru-row m-b-sm"
    >
      <span class="cru-number badge badge-default badge-numero-redondo-md">
        {{ index + 1 }}
      </span>
      <img
        :src="dato.usuario.foto_url"
        :title="fullname(dato.usuario)"
        data-toggle="tooltip"
        data-placement="top"
        class="cru-thumbnail usuario-thumbnail img-responsive img-circle img-thumbnail usuario-thumbnail-sm"
      >
      <div class="cru-bar-wrapper">
        <div class="cru-label">
          {{ fullname(dato.usuario) }}
        </div>
        <div class="cru-bar-body-wrapper animated fadeInLeft slow" :style="`width: ${dato.porcentaje}%`">
          <div class="cru-bar-body" :style="getBarStyle(dato, index)"></div>
          <div class="cru-value">
            {{ dato.total }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usuarios } from 'cifra-api-js';
import { BACKGROUND_COLORS, BORDER_COLORS } from './ChartBarras';
import NoHayDatos from './NoHayDatos.vue';

/*
Chart de barras horizontales donde muestra la foto del usuario a la izquierda,
el nombre encima de la barra y al final de la barra un valor
 */
export default {
  components: { NoHayDatos },
  props: {
    // Array de objeto del tipo [{usuario: {nombre: 'xxx', ...}, total: 7}]
    dataset: { type: Array, required: true },
  },
  computed: {
    // Array de objetos con un campo "total" que calcularemos su porcentaje
    // El 100% será el valor más alto y luego el resto se calcula en proporción
    datasetConPorcentaje() {
      if (this.dataset.length < 1) return this.dataset;

      const maximo = Math.max(...this.dataset.map((dato) => (dato.total)));
      return this.dataset.map((data) => (
        {
          ...data,
          porcentaje: Math.round((data.total * 100) / maximo),
        }
      ));
    },
  },
  methods: {
    fullname: usuarios.fullname,
    getBarStyle(dato, index) {
      return {
        'background-color': BACKGROUND_COLORS[index],
        border: `1px solid ${BORDER_COLORS[index]}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .chart-ranking-usuarios {
    .cru-row {
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      .cru-number {
        margin-right: 10px;
      }
      > img {
        margin-right: 10px;
      }
      .cru-label {
        display: block;
        margin-left: 2px;
      }
      .cru-bar-wrapper {
        flex-grow: 1;

        .cru-bar-body-wrapper {
          display: flex;
          -webkit-animation-duration: 1s;
          animation-duration: 1s;

          .cru-bar-body {
            background-color: red;
            border-radius: 0 10px 10px 0;
            flex-grow: 1;
          }

          .cru-value {
            display: inline-block;
            padding-left: 10px;
            align-self: flex-end;
          }
        }
      }
    }
  }
</style>
